export default __webpack_public_path__ + "ead0c07228d6d081f3a9e8774450cbad.png";